import React, { useState } from "react";
import { toast } from "sonner";
import { MapPin, Phone, Mail, Send } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";

export default function Contact() {
    const [f, setF] = useState({ name: "", phone: "", email: "", message: "" });
    const submit = (e) => {
        e.preventDefault();
        toast.success("Thanks! We'll get back to you within 24 hours.");
        setF({ name: "", phone: "", email: "", message: "" });
    };

    return (
        <div className="bg-slate-50 min-h-screen py-16" data-testid="contact-page">
            <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 grid lg:grid-cols-2 gap-12">
                <div>
                    <div className="text-xs font-mono-plex uppercase tracking-[0.2em] text-blue-700 mb-4">// Get In Touch</div>
                    <h1 className="font-heading font-black text-5xl tracking-tighter text-slate-900">Let's talk fuel.</h1>
                    <p className="mt-6 text-slate-600 leading-relaxed max-w-lg">
                        Bulk order? Monthly supply contract? Emergency delivery? Reach out — our dispatch team responds within 30 minutes on business hours.
                    </p>

                    <div className="mt-10 space-y-6">
                        <Info icon={MapPin} label="Office">D-49 Pratap Baug Society, Above Vaishali Travels, Nr. Shivaji Circle, Munjmahuda, Akota, Vadodara — 390020</Info>
                        <Info icon={Phone} label="Phone / WhatsApp">+91 95124 77777</Info>
                        <Info icon={Mail} label="Email">vaishalifuels20@gmail.com</Info>
                        <Info icon={MapPin} label="VAT No.">24190206382</Info>
                    </div>

                    <div className="mt-10 border-t border-slate-200 pt-6 text-xs text-slate-500 font-mono-plex uppercase tracking-widest">
                        Operating Hours · Mon–Sat 07:00–22:00 · Sun 09:00–18:00
                    </div>
                </div>

                <form onSubmit={submit} className="bg-white border border-slate-200 rounded-sm p-8 space-y-4">
                    <div className="grid sm:grid-cols-2 gap-4">
                        <Field label="Name*">
                            <Input required value={f.name} onChange={e => setF({ ...f, name: e.target.value })} className="rounded-sm" data-testid="contact-name-input" />
                        </Field>
                        <Field label="Phone*">
                            <Input required value={f.phone} onChange={e => setF({ ...f, phone: e.target.value })} className="rounded-sm" data-testid="contact-phone-input" />
                        </Field>
                    </div>
                    <Field label="Email">
                        <Input type="email" value={f.email} onChange={e => setF({ ...f, email: e.target.value })} className="rounded-sm" data-testid="contact-email-input" />
                    </Field>
                    <Field label="How can we help?*">
                        <Textarea required rows={5} value={f.message} onChange={e => setF({ ...f, message: e.target.value })} className="rounded-sm" data-testid="contact-message-input" />
                    </Field>
                    <Button type="submit" className="w-full h-11 rounded-sm bg-blue-700 hover:bg-blue-800 font-bold uppercase tracking-wider" data-testid="contact-submit-btn">
                        <Send className="w-4 h-4 mr-2" /> Send Message
                    </Button>
                </form>
            </div>
        </div>
    );
}

function Info({ icon: Icon, label, children }) {
    return (
        <div className="flex items-start gap-4">
            <div className="w-10 h-10 bg-slate-900 flex items-center justify-center rounded-sm shrink-0">
                <Icon className="w-4 h-4 text-yellow-400" />
            </div>
            <div>
                <div className="text-[10px] uppercase tracking-widest text-slate-500 font-mono-plex">{label}</div>
                <div className="text-slate-900 font-heading font-bold">{children}</div>
            </div>
        </div>
    );
}

function Field({ label, children }) {
    return (
        <div>
            <Label className="text-[11px] font-bold uppercase tracking-widest text-slate-500 mb-1.5 block">{label}</Label>
            {children}
        </div>
    );
}
